import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-id-card',
    templateUrl: './id-card.component.svg',
    styleUrls: ['./id-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IdCardComponent {}
